<!-- datetime时间选择器 -->
<template>
  <div class="form_date_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-cell-group>
      <van-field
        :label="layout === 'horizontal' ? option.label : null "
        :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed' : '') : '' "
        v-model="option.value"
        is-link
        readonly
        :name="option.name"
        :placeholder="option.placeholder"
        @click="handlePick"
        :error-message="errorMessage"
        :rules="[
          {
            validator: asyncValidator,
            message: $t('book.validator.require')
          },
        ]"
      />
    </van-cell-group>
    <van-popup
      v-model="show"
      position="bottom"
    >
      <van-datetime-picker
        v-if="dateSty === 1"
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <van-datetime-picker
        v-else-if="dateSty === 2"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <van-datetime-picker
        v-else-if="dateSty === 3"
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <van-datetime-picker
        v-else-if="dateSty === 4"
        v-model="currentDate"
        type="time"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { FormatDateTime } from '@/assets/js/utils'
export default {
  name: 'FormDateTime',
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
    // dateType: {
    //   type: String,
    //   default: '年-月-日 时:分'
    // }
  },
  data() {
    return {
      show: false,
      // value: '2020-03-11 11:26',
      currentDate: new Date(),
      dateSty: 0,
      error: false,
      errorMessage: '',
      minDate: new Date(new Date().getFullYear() - 500, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 100, 11, 31),
    }
  },

  components: {},

  watch: {
    option: {
      handler(value) {
        let tempType = value.dataStyle
        if (tempType === '年-月-日 时:分') {
          this.dateSty = 1
        } else if (tempType === '年-月-日') {
          this.dateSty = 2
        } else if (tempType === '年-月') {
          this.dateSty = 3
        } else if (tempType === '时:分') {
          this.dateSty = 4
          this.currentDate = FormatDateTime(new Date(), 'time')
        }
        if (value.value.length > 0) {
          this.asyncValidator(value.value)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    //格式校验方法
    asyncValidator(value) {
      return new Promise((resolve) => {
        if (value.length > 0) {
          resolve(this.SetCheckSuccMsg())
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('book.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },
    // 开始选择
    handlePick() {
      this.show = true
    },
    // 获取选择时间
    getPickedDate(val) {
      let dateStr = ''
      if (this.dateSty === 1) {
        dateStr = FormatDateTime(val, 'dateTime')
      } else if (this.dateSty === 2) {
        dateStr = FormatDateTime(val, 'date')
      } else if (this.dateSty === 3) {
        dateStr = FormatDateTime(val, 'year-month')
      } else if (this.dateSty === 4) {
        dateStr = val
      }
      this.$emit('listenDateChanged', this.option.name, dateStr)
      // console.log(dateStr)
    },

    onConfirm(value) {
      // this.value = FormatDateTime(value, 'dateTime')
      // console.log(value)
      this.getPickedDate(value)
      this.asyncValidator(this.option.value)
      this.show = false
    },
    onCancel() {
      this.show = false
    },
  },

  mounted() { },
}
</script>
<style lang="less" scoped></style>
